import axiosInstance from "./config";

export const loginAdmin = async (data) => {
  const response = await axiosInstance.post("/auth/login", data);

  if (response.data.success) {
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("role", response.data.role);
  }

  return response.data;
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
};
